import { useMemo } from "react";

import { useAppSelector } from "./redux/store";
import { useAccountSubTotalValue } from "./redux/accountSlice";
import { ShoppingCartErrors } from "./redux/shoppingCartSlice";
import { useCurrency } from "../components/Currencies/useCurrency.ts";

export default function useOrderLimits() {
  const orderLimitsEnabled = useAppSelector((state) => state.global.salesarea?.orderLimits);
  const minOrderValue = useAppSelector((state) => state.global.sessionState?.minOrderValue);
  const maxOrderValue = useAppSelector((state) => Number(state.global.salesarea?.maxOrderValue ?? Number.MAX_VALUE));
  const toCurrency = useCurrency();

  const amountForOrderLimits = useAccountSubTotalValue();

  const errors = useMemo(() => {
    const errors: ShoppingCartErrors = {};
    // Check orderLimits
    if (orderLimitsEnabled) {
      if (minOrderValue > 0 && minOrderValue > amountForOrderLimits) {
        errors.minOrderValueError = {
          id: "ShoppingCart.errors.minOrderValueError",
          values: { amount: toCurrency(Number(minOrderValue) ?? 0) },
        };
      }
      if (maxOrderValue > 0 && maxOrderValue < amountForOrderLimits) {
        errors.maxOrderValueError = {
          id: "ShoppingCart.errors.maxOrderValueError",
          values: { amount: toCurrency(Number(maxOrderValue) ?? 0) },
        };
      }
    }

    return errors;
  }, [amountForOrderLimits, toCurrency, maxOrderValue, minOrderValue, orderLimitsEnabled]);

  const isValid = useMemo(() => {
    return Object.keys(errors).length === 0;
  }, [errors]);

  return { errors, isValid };
}
